// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1b0f37e","455":"e3c47c3b","977":"c744ed8c"}[chunkId] + ".chunk.js";
};